import * as React from "react";
import { useEffect, Fragment } from "react";
import List from "@mui/material/List";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import { FaRegCircleUser } from "react-icons/fa6";
import IconButton from "@mui/material/IconButton";
import CssBaseline from "@mui/material/CssBaseline";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineNotifications } from "react-icons/md";
import ListItemButton from "@mui/material/ListItemButton";
import { AppBar, Toolbar, Box, styled, Typography } from "@mui/material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

import pages from "../../../constants/pages";
import DigipassLogo from "../assets/digipasslogo.svg";
import { signOutMember } from "../../../redux/slices/memberSlice";

import useAxios from ".././.././../hooks/useAxios";
import ENV from "../../../config/config";

const StyledAppBar = styled(AppBar)({
  background: "linear-gradient(90deg, #ffffff, #ffffff)",
});

const MenuItems = styled("div")({
  display: "flex",
  alignItems: "center",
  "& a": {
    color: "#ffffff",
    fontWeight: 500,
    textDecoration: "none",
    fontSize: "16px",
    margin: "0 1rem",
    position: "relative",
    "&:hover": {
      color: "#ffde03",
      "&::before": {
        content: "''",
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "-2px",
        height: "3px",
        background: "#ffde03",
        transition: "width 0.3s ease",
        width: "100%",
      },
    },
  },
});

const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    backgroundColor: "rgb(255 255 255)",
    color: "#333",
    marginTop: "30px",
  },
});

export default function MenuNavbar(props) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [logo, setLogo] = React.useState(DigipassLogo);

  const [disableOption, setDisableOption] = React.useState(
    window.location.origin.includes("https://kyc.globalfintechfest.com")
  );

  const [profileVerify, setProfileVerify] = React.useState("");

  useEffect(() => {
    setDisableOption(
      window.location.origin.includes("https://kyc.globalfintechfest.com")
    );
  });

  useEffect(() => {
    if (sessionStorage.getItem("authToken")) {
      axios({
        url: "/admin/business/get-business-theme",
        customAuthToken: sessionStorage.getItem("authToken"),
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setLogo(response.data.logo);
        }
      });
    }
  }, []);

  const navItems = [
    // { text: "Home", link: pages.home.route },
    // { text: "Appointment", link: pages.AppointmentBooking.route },
    {
      text: "History",
      link: !visitorData.ID ? pages.appointment.route : pages.Transaction.route,
    },
    visitorData.ID && visitorData.userTypeIds.includes(5)
      ? {
          text: "Gate Check-In",
          link: !visitorData.ID
            ? pages.appointment.route
            : pages.AutoGateOpen.route,
        }
      : {},
    visitorData.ID && visitorData.userTypeIds.includes(5)
      ? {
          text: "Hotel Check-In",
          link: !visitorData.ID
            ? pages.appointment.route
            : pages.CheckInPage.route,
        }
      : {},
    visitorData.ID && visitorData.userTypeIds.includes(4)
      ? {
          text: "Appointment Requests",
          link:
            pages.EmployeeDetailsPage.route + "?visitor_id=" + visitorData.ID,
        }
      : {},
    visitorData.ID && visitorData.userTypeIds.includes(3)
      ? {
          text: "Outing Pass",
          link: pages.CampusUserPage.route,
        }
      : {},
    {
      text: "Settings",
      link: pages.SettingsPage.route,
    },

    visitorData?.employeeDetails?.[0]?.badge_id ==
    (ENV === "main"
      ? "9d5813c68d3148a4bfb737629427bd32"
      : "6134b3a51c3641b1ba42fee57c6f5ac9")
      ? { text: "Check In / Check Out", link: pages.GuardFlow.route }
      : {},

    visitorData?.employeeDetails?.[0]?.badge_id ==
    (ENV === "main"
      ? "9d5813c68d3148a4bfb737629427bd32"
      : "6134b3a51c3641b1ba42fee57c6f5ac9")
      ? { text: "Find Users", link: pages.GuardUserDetails.route }
      : {},

    visitorData?.employeeDetails?.[0]?.badge_id ==
    (ENV === "main"
      ? "9d5813c68d3148a4bfb737629427bd32"
      : "6134b3a51c3641b1ba42fee57c6f5ac9")
      ? { text: "Gate Entry", link: pages.gateEntryRequest.route }
      : {},
    // { text: "Scan QR", link: pages.ScanQR.route },
    // { text: "Guest Verification", link: pages.GuestVerification.route },

    visitorData.ID ? { text: "Log Out", link: pages.home.route } : {},
  ];

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (!location.pathname.includes("event")) {
      sessionStorage.removeItem("buttonBackground");
      sessionStorage.removeItem("buttonColor");
    }
  }, [location.pathname]);

  const drawer = (
    <Box
      sx={{ textAlign: "center", marginTop: "0rem", padding: "1rem" }}
      onClick={handleDrawerToggle}
    >
      <List>
        {navItems
          .filter((item) => item.text)
          .map((item) => (
            <Fragment key={item.text}>
              <ListItem
                disablePadding
                onClick={() => {
                  navigate(
                    visitorData.ID ? item.link : pages.appointment.route
                  );
                }}
              >
                <ListItemButton
                  onClick={() =>
                    item.text === "Log Out" && dispatch(signOutMember())
                  }
                >
                  <ListItemText
                    primary={
                      <Typography
                        component={Link}
                        sx={{
                          color: location.pathname.includes("event")
                            ? sessionStorage.getItem("buttonBackground") ||
                              "rgb(84, 82, 238)"
                            : "rgb(84, 82, 238)",
                          fontWeight: 600,
                          textDecoration: "none",
                          fontSize: "1rem",
                          "&:hover": {
                            color: location.pathname.includes("event")
                              ? sessionStorage.getItem("buttonBackground") ||
                                "rgb(84, 82, 238)"
                              : "rgb(57, 54, 239)",
                          },
                        }}
                      >
                        {item.text}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
              <Divider />
            </Fragment>
          ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window?.document.body : undefined;

  const handleProfile = () => {
    if (!localStorage.getItem("authToken")) {
      navigate(pages.appointment.route);
    } else {
      navigate(pages.SettingsPage.route);
    }
  };

  useEffect(() => {
    setProfileVerify(localStorage.getItem(window.btoa(visitorData.ID)));
  });

  return (
    <Box
      sx={{
        display: "flex",
        position: "fixed",
        width: "100%",
        background: "white",
        zIndex: "9999",
        boxShadow: "0px 0px 20px 1px #c3c3c3",
        pointerEvents: disableOption ? "none" : "auto",
      }}
    >
      <CssBaseline />
      <StyledAppBar position="static">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              disabled={disableOption}
            >
              <MenuIcon
                style={{
                  color: location.pathname.includes("event")
                    ? sessionStorage.getItem("buttonBackground") ||
                      "rgb(84, 82, 238)"
                    : "#3936EF",
                }}
              />
            </IconButton>

            <img
              src={logo}
              width={"145px"}
              onClick={() => {
                navigate(pages.home.route);
              }}
            />

            {/* <Typography
              variant="h3"
              color={
                location.pathname.includes("event")
                  ? sessionStorage.getItem("buttonBackground") ||
                    "rgb(84, 82, 238)"
                  : "rgb(84, 82, 238)"
              }
              fontWeight={900}
              onClick={() => {
                navigate(pages.home.route);
              }}
            >
              Digipass
            </Typography> */}
          </Box>
          <MenuItems sx={{ display: { xs: "none", sm: "flex" } }}></MenuItems>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <IconButton color="inherit">
              <MdOutlineNotifications
                style={{
                  color: location.pathname.includes("event")
                    ? sessionStorage.getItem("buttonBackground") ||
                      "rgb(84, 82, 238)"
                    : "#3936EF",
                  fontSize: "24px",
                }}
              />
            </IconButton> */}

            <IconButton color="inherit" onClick={() => handleProfile()}>
              {profileVerify == "false" && (
                <PriorityHighIcon
                  style={{
                    color: "#ff6b6b",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    background: "#ffffff",
                    borderRadius: "10px",
                    fontSize: "20px",
                    border: "2px solid",
                  }}
                />
              )}
              <FaRegCircleUser
                style={{
                  color: location.pathname.includes("event")
                    ? sessionStorage.getItem("buttonBackground") ||
                      "rgb(84, 82, 238)"
                    : "#3936EF",
                  fontSize: "24px",
                }}
              />
            </IconButton>
          </Box>
        </Toolbar>
      </StyledAppBar>
      <Box component="nav">
        <StyledDrawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          disabled={disableOption}
        >
          {drawer}
        </StyledDrawer>
      </Box>
    </Box>
  );
}
